import { useProducts } from "@/common/hooks/queries/useProducts";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { ProductData } from "@/common/types/product.type";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import DashboardFilterSheet from "../DashboardFilterSheet";

const DashboardFilterProductSheet = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch, instantSearch] = useDebounce('');

  const {
    data: productsOptions,
  } = useProducts({
    filters: {
      search,
    },
    mapper: Mapper.mapToOptions<ProductData>({
      labelFieldName: 'display_name',
      valueFieldName: 'id',
    }),
  });

  return (
    <DashboardFilterSheet
      filterKey={DashboardFilters.Product}
      options={productsOptions}
      filters={filters}
      setFilters={setFilters}
      instantSearch={instantSearch}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterProductSheet;
